import { H2 } from '@blueprintjs/core';
import { ReactElement } from 'react';

export function AdminsPermissionsPage(): ReactElement {
	return (
		<div>
			<H2 className="bp4-heading">Admins permissions</H2>
		</div>
	);
}
